export default {"src":"/_next/static/image/public/images/ic_radio_checked.21b4da404c6c9aedc9b880d4ec49c4d7.svg","height":24,"width":24};